import FactureXDashboardView from "../views/FactureXDashboardView.vue";
import FactureXClientView from "../views/FactureXClientView.vue";
import FactureXOutgoingInvoiceView from "@/invoice-transmission/views/FactureXOutgoingInvoiceView.vue";
import FactureXIncomingInvoiceView from "@/invoice-transmission/views/FactureXIncomingInvoiceView.vue";
import FactureXEReportingView from "@/invoice-transmission/views/FactureXEReportingView.vue";

export const factureXRoutes = [
  {
    path: "/facture-x-dashboard",
    name: "FactureXDashboard",
    component: FactureXDashboardView,
  },
  {
    path: "/facture-x-outgoing-invoices",
    name: "FactureXOutgoingInvoices",
    component: FactureXOutgoingInvoiceView,
  },
  {
    path: "/facture-x-incoming-invoices",
    name: "FactureXIncomingInvoices",
    component: FactureXIncomingInvoiceView,
  },
  {
    path: "/facture-x-e-reporting",
    name: "FactureXEReporting",
    component: FactureXEReportingView,
  },
  {
    path: "/facture-x-clients",
    name: "FactureXClients",
    component: FactureXClientView,
  },
];